import React from 'react';
import CIcon from '@coreui/icons-react';
import { CLink } from '@coreui/react';
import { AI_INSIGHTS_TEMPLATE_STATUS } from '../../../../../../constants';
import CSwitch from '../../../../../migration/CSwitch';
import Tippy from '@tippyjs/react';

const ViewTemplateCard = ({ viewReport, index, onToggle, onEditTemplate, onDeleteTemplate }) => (
     <div index={index} className="row-rule d-flex justify-content-between">
          <div className="info-wrap d-flex justify-content-between align-items-center">
               <div className="info-title">
                    <h4>{viewReport.name}</h4>
                    {viewReport.description && (
                         <div className="d-inline-flex tooltip-schedule-card">
                              <Tippy
                                   content={
                                        <div className="block-tooltip-text">
                                             <span>{viewReport.description}</span>
                                        </div>
                                   }
                              >
                                   <CIcon icon="icon-info" height={14} />
                              </Tippy>
                         </div>
                    )}
               </div>
          </div>
          <div className="options-wrapper d-flex">
               <div className="option-item hover-show-tooltip">
                    <Tippy
                         content={
                              <div className="block-tooltip-text">
                                   <span>Edit Template</span>
                              </div>
                         }
                    >
                         <CLink className="option text-primary" onClick={onEditTemplate}>
                              <CIcon icon="icon-pencil" height={14} />
                         </CLink>
                    </Tippy>
               </div>
               <div className="option-item hover-show-tooltip">
                    <Tippy
                         content={
                              <div className="block-tooltip-text">
                                   <span>Delete Template</span>
                              </div>
                         }
                    >
                         <CLink className="option option-item-delete" onClick={onDeleteTemplate}>
                              <CIcon icon="iconDeleteField" className="icon-delete pointer" />
                         </CLink>
                    </Tippy>
               </div>
               <div className="option-item switch-item hover-show-tooltip">
                    <Tippy
                         content={
                              <div className="block-tooltip-text">
                                   <span>{viewReport.status === AI_INSIGHTS_TEMPLATE_STATUS.ACTIVE ? 'Inactive Template' : 'Active Template'}</span>
                              </div>
                         }
                    >
                         <span className="option">
                              <CSwitch
                                   color={viewReport.status ? 'success' : 'light'}
                                   checked={viewReport.status === AI_INSIGHTS_TEMPLATE_STATUS.ACTIVE}
                                   value={viewReport.status === AI_INSIGHTS_TEMPLATE_STATUS.ACTIVE}
                                   shape="pill"
                                   tabIndex="0"
                                   size="sm"
                                   onChange={onToggle}
                                   disabled={viewReport.status === AI_INSIGHTS_TEMPLATE_STATUS.DRAFT}
                              />
                         </span>
                    </Tippy>
               </div>
          </div>
     </div>
);

export default ViewTemplateCard;
